export const OFFER_MAX_RESIDUAL_VALUE_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancialMaxResidualValueComputed";
export const OFFER_FINANCIAL_PRODUCT_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.OfferFinancialProductInvalidated";
export const FAVORITE_PRODUCT_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.FavoriteProductCompleted";
export const DELETE_PRODUCT_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.DeleteProductCompleted";
export const SIMULATIONS_RECOMPUTE_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.RecomputeSimulationsCompleted";
export const SIMULATION_SELECTION_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.SelectSimulationCompleted";
export const FINANCIAL_PRODUCT_LIST_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.FinancialProductListComputed";
export const SIMULATION_BASIC_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.SimulationBasicComputed";
export const SIMULATION_COMPUTED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.SimulationComputed";
export const SIMULATION_VALIDATED = "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.ValidateFinancialProductForSimulationFinished";
export const FINANCIAL_PRODUCTS_TO_ADD_RETRIEVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.FinancialProductsToAddRetrieved";
export const FILTER_SIMULATIONS_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.FilterSimulationsCompleted";
export const SIMULATION_MESSAGES_PROCESSED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.SimulationMessagesProcessed";
